import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/solid/arrow-up.svg'
import BaseIcon from '../../BaseIcon'

const ChartLineUp = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 448 512" />
}

ChartLineUp.propTypes = {
	className: PropTypes.string,
}

ChartLineUp.defaultProps = {
	className: null,
}
export default ChartLineUp
